export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/14ed8dc335eec8ccd043173219a4387f.svg";